import React, { useContext } from 'react';
import { WaterfallContextProps } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext.props';

const WaterfallContext = React.createContext<WaterfallContextProps>({
  companyList: [],
  measurementDates: [],
  capTableList: [],
  onChange: () => [],
  workbookData: undefined,
  format: { currency: {} },
  formatDispatch: () => {},
});

export const useWaterfallContext = () => useContext(WaterfallContext);

export default WaterfallContext;
